import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductDeleteIconComponent } from './product-delete-icon.component';


@NgModule({
  declarations: [
    ProductDeleteIconComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    ProductDeleteIconComponent,
  ]
})
export class ProductDeleteIconModule { }
